import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import TotalSales from '@/components/v2/ecommerce/TotalSales';
import SalesGrowth from '@/components/v2/ecommerce/SalesGrowth';
import Visitors from '@/components/v2/Visitors';
import VisitorsRetention from '@/components/v2/VisitorsRetention';
import VisitorsRetentionGrowth from '@/components/v2/VisitorsRetentionGrowth';
import VisitedDays from '@/components/v2/VisitedDays';
import Sales from '@/components/v2/Sales';
import AnalyticsLayout from '@/views/v2/layouts/b2b/Analytics.vue';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import Graph from '@/components/v2/Graph';
import MostViewedProducts from '@/components/v2/ecommerce/MostViewedProducts.vue';
import MostSoldProducts from '@/components/v2/ecommerce/MostSoldProducts.vue';
let Performance = class Performance extends Mixins(RouterParamsAppMixin) {
};
Performance = __decorate([
    Component({
        components: {
            AnalyticsLayout,
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
            Graph,
            TotalSales,
            SalesGrowth,
            Visitors,
            VisitedDays,
            VisitorsRetention,
            VisitorsRetentionGrowth,
            Sales,
            MostViewedProducts,
            MostSoldProducts,
        },
    })
], Performance);
export default Performance;
